module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-box-dc5df7aabace62ab9ec06ebb13cbe360.svg";